import { Smartphone } from 'lucide-react'

import { usePhoneCheck } from '@/api/endpoints/settings'
import { Button } from '@/components/ui/Button'
import { errorMessage } from '@/lib/errors'
import { phoneCheckVerdict } from './phoneCheck'
import styles from './PhoneCheckPanel.module.scss'

/**
 * "Testar celular", no molde do teste do Ollama do desktop: confere a conexão
 * com o celular que aplica a capa dos Shorts nos canais sem verificação. Cada
 * passo aparece com o resultado e o tempo. Só o admin roda, porque acende a
 * tela do aparelho; a API responde 403 aos outros e 429 dentro de 30 s.
 */
export function PhoneCheckPanel() {
  const check = usePhoneCheck()
  const result = check.data
  const verdict = result ? phoneCheckVerdict(result) : null

  return (
    <div className={styles.panel}>
      <div className={styles.row}>
        <Button
          type="button"
          variant="secondary"
          leadingIcon={<Smartphone />}
          disabled={check.isPending}
          onClick={() => {
            check.mutate()
          }}
        >
          {check.isPending ? 'Testando…' : 'Testar celular'}
        </Button>
        {verdict && !check.isPending ? (
          <span className={verdict.ok ? styles.ok : styles.fail} role="status">
            {verdict.ok ? '✅' : '⚠️'} {verdict.text}
          </span>
        ) : null}
        {check.isError ? (
          <span className={styles.fail} role="alert">
            ⚠️ {errorMessage(check.error, 'Não foi possível testar agora.')}
          </span>
        ) : null}
      </div>
      {result && result.steps.length > 0 ? (
        <ul className={styles.steps}>
          {result.steps.map((step) => (
            <li key={step.key} className={step.ok ? styles.stepOk : styles.stepFail}>
              <span>{step.ok ? '✅' : '⚠️'}</span>
              <span className={styles.stepLabel}>{step.label}</span>
              <span className={styles.stepDetail}>{step.detail}</span>
              <span className={styles.stepMs}>{step.ms} ms</span>
            </li>
          ))}
        </ul>
      ) : null}
      <span className={styles.hint}>
        Confere o servidor ADB, a autorização do aparelho, o agente de automação, se ele obedece
        (acende a tela e responde a um eco) e a versão do app do YouTube. Não abre o YouTube nem
        salva nada, e apaga a tela no fim. Se uma drenagem estiver usando o celular, o teste não
        toca nele.
      </span>
    </div>
  )
}
